// extracted by mini-css-extract-plugin
export default {"btn":"ButtonDesign_btn__6mn0V"};